<template>
  <div>
    <b-card>
      <section v-show="loading.tabs" style="display:flex">
        <b-skeleton type="text" class="col-1 m-1"></b-skeleton>
        <b-skeleton type="text" class="col-1 m-1"></b-skeleton>
        <b-skeleton type="text" class="col-1 m-1"></b-skeleton>
        <b-skeleton type="text" class="col-1 m-1"></b-skeleton>
        <b-skeleton type="text" class="col-1 m-1"></b-skeleton>
      </section>
      <section v-show="loading.tabs" style="display:flex">
        <b-skeleton type="input" class="col-2 m-1"/>
        <b-skeleton type="input" class="col-2 m-1"/>
        <b-skeleton type="button" class="col-1 m-1"/>
        <b-skeleton type="button" class="col-1 m-1"/>
        <b-skeleton type="button" class="col-1 m-1"/>
      </section>
      <section v-show="loading.tabs" style="display:flex" class="m-1">
        <b-skeleton-table :rows="8" :columns="8"/>
      </section>
      <b-tabs v-show="!loading.tabs"  align="left" class="tab-primary" v-model="tabIndex" :key="KeyTab">
        <can-access v-bind="showTabsDeliveries">
          <b-tab v-if="showCreateTabToSellers || showTabByException">
            <template #title>
              <div class="tab-title">
                <feather-icon icon="SendIcon" />
                <span> {{$t('Crear envío')}} </span>
              </div>
            </template>
            <create-deliveries @changeTab="changeTab" class="pt-1"></create-deliveries>
          </b-tab>
          <b-tab v-if="showCreateTabToSellers || showTabByException" lazy>
            <template #title>
              <div>
                <feather-icon icon="FileTextIcon" />
                <span> {{$t('Generar etiquetas')}} </span>
              </div>
            </template>
            <generate-labels @changeTab="changeTab"/>
          </b-tab>
          <b-tab v-if="showCreateTabToSellers" lazy>
            <template #title>
              <div>
                <feather-icon icon="FileTextIcon" />
                <span> {{$t('Con observación')}} </span>
              </div>
            </template>
            <observation @changeTab="changeTab" />
          </b-tab>
          <b-tab lazy>
            <template #title>
              <div>
                <feather-icon icon="PrinterIcon" />
                <span> {{$t('Imprimir')}} </span>
              </div>
            </template>
            <print />
          </b-tab>
          <b-tab lazy>
            <template #title>
              <div class="tab-title">
                <feather-icon icon="FileIcon" />
                <span> {{$t('Manifiesto')}} </span>
              </div>
            </template>
            <list-manifest />
          </b-tab>
        </can-access>
        <b-tab lazy v-if="!sellerProfile">
          <template #title>
            <div class="tab-title">
              <feather-icon icon="TruckIcon" />
              <span> {{$t('Retiros')}} </span>
            </div>
          </template>
          <list-pickups />
        </b-tab>
        <can-access v-bind="showTabsDeliveries">
          <b-tab lazy>
            <template #title>
              <div>
                <feather-icon icon="FileTextIcon" />
                <span> {{$t('Impresos')}} </span>
              </div>
            </template>
            <printed />
        </b-tab>
        </can-access>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
import CreateDeliveries from './new-delivery/CreateDelivery.vue'
import GenerateLabels from './generate-labels/GenerateLabels.vue'
import Observation from './observation/Observation.vue'
import Print from './print/Print.vue'
import Printed from './printed/Printed.vue'
import ListManifest from '@/views/modules/manifest/List.vue'
import ListPickups from './pickups/ListPickups.vue'
import { mapGetters } from 'vuex'

export default {
  components: { CreateDeliveries, GenerateLabels, Observation, Print, Printed, ListManifest, ListPickups },
  data () {
    return {
      tabIndex: 0,
      KeyTab: 1,
      tabsName: {
        create: 0,
        labels: 1,
        rejected: 2,
        print: 3,
        summaries: 4,
        pickups: 5,
        printed: 6
      },
      loading: {
        tabs: true
      },
      haveException: false,
      showTabsDeliveries: {
        permission: 'canTabsDelivery',
        module: 'deliveries-create',
        allRoles: true,
        section: 'general'
      }
    }
  },
  mounted () {
    if (this.mySession) this.checkPermissionsToView()

    this.$nextTick(() => {
      // Obtener el hash de la URL al cargar el componente
      const hash = window.location.hash.replace('#', '')
      // Verificar si el hash está en las claves de tabsName
      if (hash in this.tabsName) {
        // Actualizar el tabIndex basado en el hash
        this.tabIndex = this.tabsName[hash]
      }
    })
  },
  watch: {
    $route(to, from) {
      const hash = to.hash.replace('#', '')
      if (hash in this.tabsName) {
        this.tabIndex = this.tabsName[hash]
      }
    },
    tabIndex (newIndex, oldIndex, e) {
      this.updateTab()
    },
    companyInfo () {
      this.loading.tabs = false
    },
    mySession () {
      this.checkPermissionsToView()
    }
  },
  methods: {
    changeTab(hash) {
      this.tabIndex = this.tabsName[hash]
    },
    updateTab() {
      // Obtener el nombre del tab basado en el newIndex
      const tabName = Object.keys(this.tabsName).find(key => this.tabsName[key] === this.tabIndex)
      // Actualizar la ruta basada en el nombre del tab
      if (tabName) {
        this.updateHash(`#${tabName}`)
      }
    },
    updateHash(newHash) {
      if (window.location.hash !== newHash) {
        history.replaceState(null, null, newHash)
      }
    },
    customizeViewSeller() {
      const tabsSellers = ['print', 'summaries', 'pickups', 'printed']
      this.tabsName = Object.fromEntries(Object.entries(this.tabsName)
        .filter(([key]) => tabsSellers.includes(key))
        .map(([key], index) => [key, index]))
    },
    checkPermissionsToView() {
      if (this.mySession.profile_type === 4) {
        this.$store.dispatch('fetchService', { name: 'getCompanyInformation', params: { company_id: this.mySession.shipper.id } })
      } else {
        this.loading.tabs = false
      }

      if (['seller'].includes(this.mySession?.role)) {
        this.customizeViewSeller()
      }
    }
  },
  computed: {
    ...mapGetters({
      companyInfo: 'getCompanyInformation',
      mySession: 'getSession'
    }),
    showTabByException() {
      return this.companyInfo?.data?.company?.customization?.show_create_tab_to_sellers ?? false
    },
    showCreateTabToSellers() {
      const showCreateTabMkp = this.companyInfo?.data?.company?.company_marketplaces[0]?.marketplace?.customization?.show_create_tab_to_sellers ?? true
      const showCreateTabSeller = this.companyInfo?.data?.company?.customization?.show_create_tab_to_sellers ?? true
      const showTabsCreateDeliveriesASeller = this.mySession?.special_permissions?.includes('lock-create-deliveries')

      if (this.mySession.profile_type === 4) {
        return false
      }

      if (showTabsCreateDeliveriesASeller) {
        return false
      } else if (['admin', 'marketplace'].includes(this.mySession?.role)) {
        return true
      } else {
        return (showCreateTabMkp && showCreateTabSeller)
      }


      // return true
    },
    sellerProfile() {
      return this.mySession?.user_access?.seller_profile
    }
  }
}
</script>